import { Link, useLocation } from "react-router-dom";
import { EmployerLandingNav } from "./nav/EmployerLandingNav";
import { EmployeeLandingNav } from "./nav/EmployeeLandingNav";
import { EmployerNav } from "./nav/EmployerNav";
import { CandidateNav } from "./nav/CandidateNav";
import { useAuth } from "@/contexts/AuthContext";
import { useProfile } from "@/contexts/ProfileContext";
export function MainNav() {
  const location = useLocation();
  const {
    user
  } = useAuth();
  const {
    profile
  } = useProfile();
  console.log('[MainNav] Rendering for path:', location.pathname, 'User authenticated:', !!user, 'User role:', profile?.role);

  // Check if user is on the jobs page or related employee pages
  const isEmployeesSection = location.pathname === '/jobs' || location.pathname.startsWith('/job/') || location.pathname === '/companies';
  const isTestCreatorSection = location.pathname.includes('/test-creator');

  // If user is logged in, show the appropriate authenticated nav
  if (user) {
    // For test creator section, use employer nav
    if (isTestCreatorSection) {
      return <EmployerNav />;
    }

    // For jobs pages with authenticated users, show role-specific nav
    if (isEmployeesSection) {
      if (profile?.role === 'candidate') {
        return <CandidateNav />;
      } else if (profile?.role === 'employer' || profile?.role === 'administrator') {
        return <EmployerNav />;
      }
    }

    // For authenticated users on other pages, show their appropriate role-based navigation
    if (profile?.role === 'candidate') {
      return <CandidateNav />;
    } else if (profile?.role === 'employer' || profile?.role === 'administrator') {
      return <EmployerNav />;
    }

    // Fallback for authenticated users with unknown role
    return <CandidateNav />;
  }

  // For public employee landing page or employee pages
  if (isEmployeesSection) {
    return <nav className="fixed top-0 left-0 right-0 z-[100] bg-background border-b border-border">
        <div className="container max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
          <div className="flex h-16 items-center justify-between">
            <Link to="/" className="flex items-center space-x-2">
              <img 
                src="/lovable-uploads/e7e0cd62-757f-4e57-b3bf-42cffdc8d843.png" 
                alt="Testera Logo" 
                className="h-8 w-8"
              />
              <span className="text-2xl font-bold text-foreground tracking-tight">
                Testera
              </span>
            </Link>
            <div className="flex items-center">
              <EmployeeLandingNav />
            </div>
          </div>
        </div>
      </nav>;
  }

  // Default to employer landing nav for public views
  return <nav className="fixed top-0 left-0 right-0 z-[100] bg-background">
      <div className="bg-background container max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img 
              src="/lovable-uploads/e7e0cd62-757f-4e57-b3bf-42cffdc8d843.png" 
              alt="Testera Logo" 
              className="h-8 w-8"
            />
            <span className="text-2xl font-bold text-foreground tracking-tight">
              Testera
            </span>
          </Link>
          <div className="flex items-center">
            <EmployerLandingNav />
          </div>
        </div>
      </div>
    </nav>;
}